import httpInstance from "../utils/httpInstance";

const coingeckoAPI = httpInstance({
    baseURL: "https://api.coingecko.com/api/v3/",
    timeout: 15000
});

export default coingeckoAPI;
